import { identity, map, isFinite, merge, pickBy, isString } from 'lodash';
import ImageResizer from '../ImageResizer';
import { getBreakpoint, getPreset } from '../Theme/selectors';
export var getSizes = function getSizes(src, responsiveSizes, originalWidth, uiTheme) {
  if (ImageResizer.isResizableImage(src) && responsiveSizes.length > 0) {
    var sizes = responsiveSizes.map(function (responsiveSize) {
      var minWidthKey = responsiveSize.minWidth,
        maxWidthKey = responsiveSize.maxWidth,
        _responsiveSize$props = responsiveSize.props.width,
        breakpointWidth = _responsiveSize$props === void 0 ? {} : _responsiveSize$props;
      var minWidth = getBreakpoint(uiTheme, minWidthKey);
      var maxWidth = getBreakpoint(uiTheme, maxWidthKey);
      if (minWidth && maxWidth) {
        return "(min-width: ".concat(minWidth, "px and max-width: ").concat(maxWidth, ") ").concat(breakpointWidth, "px");
      }
      if (minWidth) return "(min-width: ".concat(minWidth, "px) ").concat(breakpointWidth, "px");
      if (maxWidth) return "(max-width: ".concat(maxWidth, "px) ").concat(breakpointWidth, "px");
      return null;
    });
    return "".concat(sizes.join(', '), ", ").concat(originalWidth, "px");
  }
  return null;
};
var alignmentParamMap = {
  center: null,
  top: 't',
  bottom: 'b',
  left: 'l',
  right: 'r'
};
export var getAlignmentParam = function getAlignmentParam(alignment) {
  if (!isString(alignment)) {
    return null;
  }
  return alignmentParamMap[alignment.toLowerCase()] || null;
};
export var getSrcSet = function getSrcSet(src, responsiveSizes, height, width, transformation, backgroundColor, alignment, quality, outputFormat) {
  if (!ImageResizer.isResizableImage(src)) {
    return null;
  }

  // create src sizes for normal height and width as well
  var sizes = responsiveSizes.concat({
    props: {
      width: width,
      height: height,
      transformation: transformation,
      backgroundColor: backgroundColor,
      alignment: alignment,
      quality: quality
    }
  });
  return map(sizes, function (responsiveSize) {
    var _responsiveSize$props2 = responsiveSize.props,
      _responsiveSize$props3 = _responsiveSize$props2 === void 0 ? {} : _responsiveSize$props2,
      resHeight = _responsiveSize$props3.height,
      resWidth = _responsiveSize$props3.width,
      resTransformation = _responsiveSize$props3.transformation,
      resBgColor = _responsiveSize$props3.backgroundColor,
      resAlignment = _responsiveSize$props3.alignment,
      resQuality = _responsiveSize$props3.quality;
    var url = ImageResizer.resizeUrl(src, pickBy({
      h: resHeight,
      w: resWidth,
      t: resTransformation,
      a: getAlignmentParam(resAlignment),
      q: resQuality,
      bg: resTransformation === 'frame' && resBgColor ? resBgColor.substring(1) : null,
      o: outputFormat
    }, identity));
    var retinaUrl = ImageResizer.resizeUrl(src, pickBy({
      h: resHeight * 2,
      w: resWidth * 2,
      t: resTransformation,
      a: getAlignmentParam(resAlignment),
      q: resQuality,
      bg: resTransformation === 'frame' && resBgColor ? resBgColor.substring(1) : null,
      o: outputFormat
    }, identity));
    return "".concat(url, " ").concat(resWidth, "w, ").concat(retinaUrl, " ").concat(resWidth * 2, "w");
  }).join(', ');
};
export var getTransformedProps = function getTransformedProps(props) {
  var preset = getPreset(props.uiTheme, 'image', props.preset);
  var defaults = {
    backgroundColor: '#E6E6E6',
    height: 'auto',
    fullWidth: false,
    loadingAspectRatio: 9 / 16,
    maxHeight: 'none',
    maxWidth: 'none',
    width: 'auto'
  };
  var mergedProps = merge({}, defaults, pickBy(preset, identity), pickBy(props, identity));
  if (!props.LoadingAspectRatio && !preset.LoadingAspectRatio && isFinite(mergedProps.height / mergedProps.width)) {
    mergedProps.loadingAspectRatio = mergedProps.height / mergedProps.width;
  }
  return mergedProps;
};
export var getAspectRatio = function getAspectRatio(height, width) {
  if (isFinite(height / width)) {
    return height / width;
  }
  return 9 / 16;
};